
// Change date format to Haitian Kreyol in FTS feeds
// Feeds use language like "10 minutes ago" which doesn't
// have the same format in Kreyol
jQuery(function ($) {
	const twitterDates = $('.tweeter-info .time a'),
          instaDates   = $('.fts-insta-date-popup-grab'),
		  fbDates      = $('.fts-jal-fb-post-time');
	
	if (twitterDates.length) {
		twitterDates.each( function() {
			haitiDateFormatting( $( this ) );
		});
	}
	
	if (instaDates.length) {
		instaDates.each( function() {
			haitiDateFormatting( $( this ) );
		});
	}
	
	if (fbDates.length) {
		fbDates.each( function() {
			haitiDateFormatting( $( this ) );
		});
	}
});

function haitiDateFormatting( element ) {
	var matchString = element.html();
	if (/(\d?) (ane|jou|semenn|mwa|è d tan|minit|segonn) ago/i.test( matchString ) ) {
    	var stringPieces = matchString.match(/(\d?) (ane|jou|semenn|mwa|è d tan|minit|segonn) ago/i);
    	var replaceString = "Sa fè " + stringPieces[1] + " " + stringPieces[2];
    	element.html(replaceString);
	}
}

